export default "__VITE_ASSET__a9684dbd__"